import * as conf from '@/configuration/bonStock/menuStockConf';

export default function genererCritereRechercheStock() {
  return {
    auto: '',
    dateDeBon: {
      dateDebut: null,
      dateFin: null,
    },
    lieuDeStockageIds: [],
    origine: null,
    codesCommande: [],
    type: conf.BON_STOCK_TYPE_ENTREE,
    actif: 'true',
  };
}
